import Ext from 'Ext'
Ext.namespace( 'AT' );

const BaseDatePicker = Ext.extend( Ext.DatePicker,
{

    scheduleCalculator: null,

    initComponent: function ()
    {
        BaseDatePicker.superclass.initComponent.call( this );
        this.effectiveScheduleCache = {};
        this.clearText = window.messageResource.getMessage( "common.datepicker.clear" );
        this.todayText = window.messageResource.getMessage( "common.datepicker.today" );
        if( !this.minText )
            this.minText = window.messageResource.getMessage( "common.datepicker.minDateText" );
        if( !this.maxText )
            this.maxText = window.messageResource.getMessage( "common.datepicker.maxDateText" );
        this.actualMin = this.minDate ? this.minDate.clearTime() : Number.NEGATIVE_INFINITY;
        this.actualMax = this.maxDate ? this.maxDate.clearTime() : Number.POSITIVE_INFINITY;
        this.disabledDatesJoinedString = false;
        this.todayIsDisabled = false;
    },

   /**
    * This needed for correct look and feel under IE.because IE doesn't support CSS selector as following
    * .x-date-weekend.x-date-disabled - should select element which has two classes(x-date-weekend and x-date-disabled),
    * IE select only x-date-disabled or x-date-weekend, but not two at once.
    **/
    getClassNameForDisableDay: function ( className )
    {
        if( className.indexOf( "x-date-weekend" ) != -1 )
            if( className.indexOf( "x-date-nextday" ) != -1 )
                className = " x-date-disabled x-date-nextday-weekend-disabled";
            else if( className.indexOf( "x-date-prevday" ) != -1 )
                className = " x-date-disabled x-date-prevday-weekend-disabled";
            else
                className = " x-date-disabled x-date-active-weekend-disabled";
        else
            className += " x-date-disabled";

        return className;
    },

    getEffectiveSchedule: function ( startDate )
    {
        var firstDayInCalendar = new Date( startDate.getTime() );
        var endDayInCalendar = new Date( startDate.getTime() );
        firstDayInCalendar.setDate( firstDayInCalendar.getDate() + 1 );
        endDayInCalendar.setDate( endDayInCalendar.getDate() + 42 );

        var effectiveSchedule = this.effectiveScheduleCache[firstDayInCalendar.getTime()];

        //cache the schedule to prevent redundant calculations
        if( !effectiveSchedule )
        {
            effectiveSchedule = this.scheduleCalculator.getEffectiveSchedule( firstDayInCalendar, endDayInCalendar );
            this.effectiveScheduleCache[firstDayInCalendar.getTime()] = effectiveSchedule;
        }

        return effectiveSchedule;
    },

    applyWebKitWorkaround: function ()
    {
        if (Ext.isChrome) {
            var main = this.el.dom.firstChild;

            // Workaround for WebKit
            // Because main.offsetWidth in WebKit returns wrong value greater than 10000,
            // than believe that it was 175
            var w = 175;
            this.el.setWidth( w + this.el.getBorderWidth( "lr" ) );
            Ext.fly( main ).setWidth( w );
        }
    },

    setCellClasses: function ( cell, isWeekend, date, today )
    {
        cell.title = "";

        var t = date.clearTime( true ).getTime();
        cell.firstChild.dateValue = t;

        if( t == today )
        {
            cell.className += " x-date-today";
            cell.title = this.todayText;
        }

        if( isWeekend )
            cell.className += "x-date-weekend x-date-weekend";

        // disabling
        if( t < this.actualMin )
        {
            cell.className = this.getClassNameForDisableDay( cell.className );
            cell.title = this.minText;
            return;
        }
        if( t > this.actualMax )
        {
            cell.className = this.getClassNameForDisableDay( cell.className );
            cell.title = this.maxText;
            return;
        }

        if( this.disabledDatesJoinedString )
        {
            if( this.disabledDatesJoinedString.indexOf( date.getDay() ) != -1 )
            {
                cell.title = this.disabledDatesText;
                cell.className = " x-date-disabled";
            }
        }

        if( this.disabledDatesRE && this.format )
        {
            var fValue = date.dateFormat( this.format );
            if( this.disabledDatesRE.test( fValue ) )
            {
                cell.title = this.disabledDatesText.replace( "%0", fValue );
                cell.className = " x-date-disabled";
            }
        }
    },

    updateCells: function ( date )
    {
        var days = date.getDaysInMonth();
        var firstOfMonth = date.getFirstDateOfMonth();
        var startingPos = firstOfMonth.getDay() - this.startDay;

        if( startingPos <= this.startDay )
            startingPos += 7;

        var prevMonth = date.add( "mo", -1 );
        var prevStart = prevMonth.getDaysInMonth() - startingPos;

        var cells = this.cells.elements;
        var textEls = this.textNodes;
        days += startingPos;

        // convert everything to numbers so it's fast
        var d = new Date( prevMonth.getFullYear(), prevMonth.getMonth(), prevStart, 12 );
        var today = this.today().getTime();

        var effectiveSchedule = this.getEffectiveSchedule( d );


        var i = 0;
        for( ; i < startingPos; i++ )
        {
            textEls[i].innerHTML = (++prevStart);
            d.setDate( d.getDate() + 1 );
            cells[i].className = "x-date-prevday";
            this.setCellClasses( cells[i], this.isWeekend( effectiveSchedule, i ), d, today );
        }
        for( ; i < days; i++ )
        {
            var intDay = i - startingPos + 1;
            textEls[i].innerHTML = (intDay);
            d.setDate( d.getDate() + 1 );
            cells[i].className = "x-date-active";
            this.setCellClasses( cells[i], this.isWeekend( effectiveSchedule, i ), d, today );
        }
        var extraDays = 0;
        for( ; i < 42; i++ )
        {
            textEls[i].innerHTML = (++extraDays);
            d.setDate( d.getDate() + 1 );
            cells[i].className = "x-date-nextday";
            this.setCellClasses( cells[i], this.isWeekend( effectiveSchedule, i ), d, today );
        }

        this.mbtn.setText( this.monthNames[date.getMonth()] + " " + date.getFullYear() );

        this.applyWebKitWorkaround();
    },

    isWeekend: function ( effectiveSchedule, dayNumber )
    {
        return effectiveSchedule[dayNumber] == false;
    },

    initDisabledDays: function ()
    {
        BaseDatePicker.superclass.initDisabledDays.call( this );
        if( this.disabledDates )
            this.disabledDatesJoinedString = this.disabledDays ? this.disabledDays.join( "" ) : false;

        var today = this.today();
        this.todayIsDisabled =
            (today < this.actualMin || today > this.actualMax ||
            (this.disabledDatesRE && this.format && this.disabledDatesRE.test( today.dateFormat( this.format ) )) ||
            (this.disabledDatesJoinedString && this.disabledDatesJoinedString.indexOf( today.getDay() ) != -1));
    },

    // override
    onRender: function ( container, position )
    {
        BaseDatePicker.superclass.onRender.call( this, container, position );

        Ext.get(this.el).addClass("atap-base-date-picker");

        // fix some tab index issues under FF
        var as = this.el.dom.getElementsByTagName( 'a' );
        for( var i = 0; i < as.length; i++ )
            as[i].tabIndex = 0;

        var yearSwitcher = Ext.get(this.el).child(".x-date-mp");
        if ( !this.KeyListener )
            this.KeyListener = new Ext.KeyMap(Ext.getBody().parent(), {
                key: [Ext.EventObject.LEFT, Ext.EventObject.RIGHT],
                ctrl: true,
                fn: function(key, ev) {
                    if (this.isVisible() && !yearSwitcher.isVisible()) {
                        if (key === Ext.EventObject.LEFT)
                            this.showPrevMonth()
                        else
                            this.showNextMonth();
                    }
                },
                scope: this,
                stopEvent: true
            });
    },

    /**
     * Behaves as if the user clicked on an active day ('active' means the day under cursor).
     * Selects the active day and fires the 'select' event.
     */
    selectActiveDate: function ()
    {
        this.suppressActiveDayFocus = true; // Hack: Suppress automatic active day focusing in the next update().
        // Because focusing is deferred, and the date picker is usually hidden
        // after calling this method, focusing would cause a lot of trouble.
        this.setValue( this.activeDate );
        this.fireEvent( "select", this, this.value );
    },

    /**
     * Cancels the selection.
     */
    cancel: function ()
    {
        this.fireEvent( "cancel", this );
    },

    onOkClick: function ()
    {
        this.selectActiveDate();
    },

    onCancelClick: function ()
    {
        this.cancel();
    },

    // Fix issue with ExtJS Date.add method, which will return 1 March when adding or subtracting 1 year to 29 february.
    fix29februaryIssue: function ( newDate )
    {
        if( newDate.getMonth() != this.activeDate.getMonth() )
            return newDate.add( Date.DAY, -1 );
        else
            return newDate;
    },

    // override
    onMonthClick: function ( e, t )
    {
        e.stopEvent();
        var el = new Ext.Element( t );

        if( el.is( 'button.x-date-mp-ok' ) )
        {
            this.monthPickerApply( this.mpSelYear, this.mpSelMonth );
        }
        else
        {
            BaseDatePicker.superclass.onMonthClick.call( this, e, t );
        }
    },

    // override
    onMonthDblClick: function ( e, t )
    {
        e.stopEvent();
        var el = new Ext.Element( t ), pn;

        if( pn = el.up( 'td.x-date-mp-month', 2 ) )
        {
            this.monthPickerApply( this.mpSelYear, pn.dom.xmonth );
        }
        else if( pn = el.up( 'td.x-date-mp-year', 2 ) )
        {
            this.monthPickerApply( pn.dom.xyear, this.mpSelMonth );
        }
    },

    monthPickerApply: function ( year, month )
    {
        var d = new Date( year, month, (this.activeDate || this.value).getDate() );
        if( d.getMonth() != month )
        {
            // "fix" the JS rolling date conversion if needed
            d = new Date( year, month, 1 ).getLastDateOfMonth();
        }
        this.update( d, false, true );
        this.hideMonthPicker();
    },

    setMonthYearSwitchingStateIfNotSet: function ()
    {
        if( this.monthYearSwitchingState == 'off' )
        {
            if( this.activeDate.format( "j" ) == this.activeDate.getDaysInMonth() )
                this.monthYearSwitchingState = 'keep_month_end';
            else
                this.monthYearSwitchingState = 'keep_same_day';
        }
    },

    clearMonthYearSwitchingState: function ()
    {
        this.monthYearSwitchingState = 'off';
    },

    getMonthYearSwitchingState: function ()
    {
        return this.monthYearSwitchingState;
    },

    today: function ()
    {
        return window.currentUserTime().clearTime();
    },

    clear: function()
    {
        this.fireEvent("clear", this);
    },

    /**
     * Overrides function from Ext.DatePicker
     * Use correct current user time.
     */
    selectToday: function ()
    {
        if( !this.todayIsDisabled )
        {
            this.setValue( this.today() );
            this.fireEvent( "select", this, this.value );
        }
    },

    focus: function() {
        // prevent calling of this.update() on mouseOver
    }

} );

Ext.reg( 'atdatepickerbase', BaseDatePicker );

export default BaseDatePicker



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/at_base_date_picker.js